export default "__VITE_ASSET__X02JHfAd__"